import { BadgeColor } from "sprint-common-web";

import { OrderRequestSource } from "../../listing/OrderRequestListingItem";

export const resolveOrderRequestSourceBadgeColor = (source: OrderRequestSource): BadgeColor => {
    switch (source) {
        case OrderRequestSource.Shreq:
            return BadgeColor.LightGreen;
        case OrderRequestSource.Buzz:
            return BadgeColor.LightBlue;

        default:
            return BadgeColor.Gray;
    }
};
